module.exports = __webpack_public_path__ + "img/003周奎元.34c1f87d.png";